import { useQuery } from '@tanstack/react-query';
import fetchLearnerHomeInit from '../api/LearnerLearning';

export default function useLearnerHomeInit() {
  return useQuery({
    queryKey: ['learnerhomeinit'],
    queryFn: () => fetchLearnerHomeInit(),
  },
    {
      enabled: true,
    }
  )
}

